import { styles } from './main.styles';
import { template } from './main.template';
/**
 * The default template options this MF has been created with.
 * @beta
 * @privateRemarks
 * This will likely evolve into the shell style PWA + FDC3 manifest setup, but that needs more work to evolve into MVP.
 * Hosts should be able to figure out everything they will need to do to fully customise a MF. Currently, they
 * import these `defaultTemplateOptions` and the host dev overrides. Each TemplateComponents key must be a mandatory
 * override, given in hosted mode the MFs won't be registering fallbacks as this would be wasteful, bloat etc.
 * I've added the components list to the package.json \> config block for now, but I'm not using it here.
 */
export const defaultTemplateOptions = {
    anchor: 'zero-anchor',
    button: 'zero-button',
    card: 'zero-card',
    checkbox: 'zero-checkbox',
    listboxOption: 'zero-option',
    provider: 'template',
    router: 'foundation-router',
    select: 'zero-select',
    textField: 'zero-text-field',
};
/**
 * @beta
 * @remarks
 * This is the main definition of this micro frontend which is exposed for user reconfiguration.
 */
export const definition = {
    name: 'foundation-login',
    template: template(defaultTemplateOptions),
    styles: styles(defaultTemplateOptions),
};
/**
 * @internal
 * @privateRemarks
 * This is used during development of this micro frontend.
 */
export const standaloneDefinition = {
    name: 'foundation-login',
    template: template(Object.assign(Object.assign({}, defaultTemplateOptions), { provider: 'zero-design-system-provider' })),
    styles: styles(Object.assign(Object.assign({}, defaultTemplateOptions), { provider: 'zero-design-system-provider' })),
};
